import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Maintenance } from '../models/maintenance.model';
import { MaintenanceDto } from '../models/maintenance-dto.model';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private apiUrl = environment.apiUrl + environment.maintenancePath;

  constructor(private http: HttpClient) {}

  getMaintenances(): Observable<Maintenance[]> {
    return this.http.get<Maintenance[]>(this.apiUrl);
  }

  createMaintenance(maintenance: MaintenanceDto): Observable<Maintenance> {
    return this.http.post<Maintenance>(this.apiUrl, maintenance);
  }

  getMaintenance(id: number): Observable<MaintenanceDto> {
    return this.http.get<MaintenanceDto>(`${this.apiUrl}/full/${id}`);
  }

  createMaintenanceFull(maintenance: MaintenanceDto): Observable<Maintenance> {
    return this.http.post<Maintenance>(`${this.apiUrl}/full`, maintenance);
  }

  updateMaintenance(id: number, maintenance: MaintenanceDto): Observable<Maintenance> {
    return this.http.put<Maintenance>(`${this.apiUrl}/${id}`, maintenance);
  }

  deleteMaintenance(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  disabledMaintenance(maintenance: Maintenance): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}${environment.disabledPath}/${maintenance.id}`,
      maintenance,
    );
  }
}
